import * as ambassadorWixGatewaysEcomV1DeliveryRatesGateway from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.http.js';
import * as ambassadorWixGatewaysEcomV1DeliveryRatesGatewayTypes from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.types.js';
import * as ambassadorWixGatewaysEcomV1DeliveryRatesGatewayUniversalTypes from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getDeliverySolutions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayUniversalTypes.GetDeliverySolutionsRequest,
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayTypes.GetDeliverySolutionsRequest,
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayUniversalTypes.GetDeliverySolutionsResponse,
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayTypes.GetDeliverySolutionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixGatewaysEcomV1DeliveryRatesGateway.getDeliverySolutions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/get-delivery-solutions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DeliveryRatesGateway as DeliveryRatesGatewayOriginal,
  MissingDefaultDeliveryProfileEvent as MissingDefaultDeliveryProfileEventOriginal,
  GetDeliverySolutionsRequest as GetDeliverySolutionsRequestOriginal,
  DeliverableItem as DeliverableItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  SubscriptionSettings as SubscriptionSettingsOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  WeightUnit as WeightUnitOriginal,
  WeightUnitWithLiterals as WeightUnitWithLiteralsOriginal,
  UserPreference as UserPreferenceOriginal,
  ExternalReference as ExternalReferenceOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GetDeliverySolutionsResponse as GetDeliverySolutionsResponseOriginal,
  DeliverySolution as DeliverySolutionOriginal,
  DeliveryReference as DeliveryReferenceOriginal,
  DeliveryLogistics as DeliveryLogisticsOriginal,
  PickupDetails as PickupDetailsOriginal,
  PickupMethod as PickupMethodOriginal,
  PickupMethodWithLiterals as PickupMethodWithLiteralsOriginal,
  DeliveryTimeSlot as DeliveryTimeSlotOriginal,
  DeliveryCost as DeliveryCostOriginal,
  MultiCurrencyPrice as MultiCurrencyPriceOriginal,
  AdditionalCost as AdditionalCostOriginal,
  DeliveryAllocation as DeliveryAllocationOriginal,
  Carrier as CarrierOriginal,
  Region as RegionOriginal,
  ApplicableLineItems as ApplicableLineItemsOriginal,
  DeliveryCarrierError as DeliveryCarrierErrorOriginal,
  Details as DetailsOriginal,
  DetailsKindOneOf as DetailsKindOneOfOriginal,
  ApplicationError as ApplicationErrorOriginal,
  ValidationError as ValidationErrorOriginal,
  RuleType as RuleTypeOriginal,
  RuleTypeWithLiterals as RuleTypeWithLiteralsOriginal,
  FieldViolation as FieldViolationOriginal,
  SystemError as SystemErrorOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetDeliverySolutionsApplicationErrors as GetDeliverySolutionsApplicationErrorsOriginal,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.types.js';
